import {
  LOAD_APPRAISER_APPLICATION,
  LOAD_BO_APPLICATION_SUCCESS,
} from './appActions';

import initialState from './appInitialState';

const appReducer = (state = initialState(), { type, payload }) => {
  switch (type) {
    case LOAD_BO_APPLICATION_SUCCESS: {
      const { name, id } = payload;
      const { isAdmin } = payload;
      const newState = {
        ...state,
        hasLoaded: true,
        userName: name,
        userId: id,
        isAdmin,
      };
      return newState;
    }

    case LOAD_APPRAISER_APPLICATION: {
      const newState = {
        ...state,
        hasLoaded: true,
      };

      return newState;
    }

    default:
      return state;
  }
};

export default appReducer;
